import React from 'react';
import { NavLink } from 'react-router-dom';

const HeaderNavigation = ({ products }) => {
  if (!products || products.length === 0) return null;
  return (
    <ul className="main-nav no-print">
      {products.map((item, index) => {
        if (typeof item === 'function') {
          return (
            <li className="nav-button" key={index}>
              {item()}
            </li>
          );
        }

        let isUrlExternal = item.url.includes("http://") || item.url.includes("https://");

        return (      
          <li key={index}>
            {isUrlExternal && (<a href={item.url}>{item.label}</a>)}
            {!isUrlExternal && (<NavLink exact={item.url === '/' || item.exact} activeClassName="selected" to={item.url}>{item.label}</NavLink>)}
          </li>
        );
      })}
    </ul>
  );
};

export default HeaderNavigation;
